export default {
    "layers": {
        "titles": "Camadas",
        "title": "Camada",
        "list": {
            "name": "Nome"
        },
        "model": {
            "name": "Nome"
        }
    },
    "channels": {
        "titles": "Canais de Entrada",
        "title": "Canal de Entrada",
        "list": {
            "name": "Nome"
        },
        "model": {
            "name": "Nome"
        }
    },
    "priorities": {
        "titles": "Prioridades",
        "title": "Prioridade",
        "list": {
            "name": "Nome"
        },
        "model": {
            "name": "Nome"
        }
    },
    "types": {
        "titles": "Tipos",
        "title": "Tipo",
        "list": {
            "name": "Nome",
            "subtypes": "Nº Subtipos"
        },
        "model": {
            "name": "Nome",
            "icon": "Icon"
        }
    },
    "subtypes": {
        "titles": "Subtipos",
        "title": "Subtipo",
        "list": {
            "type": "Tipo",
            "name": "Nome",
            "unities": "Unidades"
        },
        "model": {
            "type": "Tipo",
            "name": "Nome"
        }
    },
    "unities": {
        "titles": "Unidades",
        "title": "Unidade",
        "list": {
            "name": "Nome",
            "email": "E-mail",
            "phone": "Contato",
            "first_process": "1ª Unidade",
            "user" : {
                "name": "Nome",
                "email": "E-mail",
                "placeholder": "Utilizador...",
                "add": "Adicionar",
                "deleteMsg": "Deseja remover o utilizador <u>{label}</u>?",
                "notFoundMsg": "Sem utilizadores associados",
                "user": "Utilizador"
            },
            "tab" : {
                "commun": "Geral",
                "types": "Tipos",
                "users": "Utilizadores"
            }
        },
        "model": {
            "name": "Nome",
            "email": "E-mail",
            "phone": "Contato",
            "first_process": "1ª Unidade",
        }
    },
    "statuses": {
        "titles": "Estados",
        "title": "Estado",
        "list": {
            "order": "Ordem",
            "name": "Nome",
            "first_process": "1º Estado",
            "last_process": "Últ. Estado",
            "guest": "Visível Munícipe",
            "color": "Côr",
            "image": "Imagem"
        },
        "model": {
            "name": "Nome",
            "order": "Ordem",
            "transform_to": "Agregar",
            "color": "Côr",
            "first_process": "Estado inicial?",
            "last_process": "Estado final?",
            "report_to": "Permite atribuir?",
            "guest": "Visível ao Munícipe?"
        },
        "help": {
            "order": "Ordem de apresentação no painel dos filtros",
            "transform_to": "Para o Munícipe, este estado é agregado em ...",
            "first_process": "Atribuir este estado quando um registo é criado?",
            "last_process": "Este estado é final?",
            "report_to": "Define a possibilidade de atribuir o registo a alguma entidade/pessoa",
            "guest": "Este estado é visível para o Munícipe?"
        }
    },
    "reminders": {
        "titles": "Avisos",
        "title": "Aviso",
        "model": {
            "name": "Nome",
            "start_at": "Desde",
            "end_at": "Até",
            "notification_id": "Notificação",
            "duration_value": "Duração",
            "duration_unit_id": "Unidade",
            "duration_condition": "Condição",
            "repeat": "Repetir",
            "status": "Ativo",
        },
        "list": {
            "name": "@:reminders.model.name",
            "start_at": "@:reminders.model.start_at",
            "end_at": "@:reminders.model.end_at",
            "status": "@:reminders.model.status",
        },
        "msg": {
            "duration": "Quando enviar esta notificação",
        },
        "help": {
            "duration_value": "Número indicativo da duração de tempo",
            "duration_unit_id": "Unidade de tempo",
        }
    },
    "edoclink_maps": {
        "titles": "EdocLink",
        "title": "EdocLink Mapa",
        "list": {
            "auto_scale": "Ajustável",
        },
        "model": {
            "name": "Nome",
            "status": "Ativo",
            "order": "Ordem",
            "page_title": "Título de Impressão",
            "scale": "Escala",
            "crs": "CRS (ex: EPSG:3763)",
            "dpi": "DPI",
            "layers": {
                "name": "Nome",
            },
        },
        "settings": {
            "title": "Impressão",
            "title_report": "Relatório",
            "title_zoom": "Zoom To Features",
            "title_upload": "Upload Vector File",
            "page_title": "EdocLink Config",
            "model": {
                "appid": "AppId",
                "layout": "Layout",
                "format": "Formato",
                "municipality": "Município",
                "title": "Título",
                "report": {
                    "status": "Relatório",
                    "title": "Template do título",
                },
                "zoom": {
                    "zoomtype": "Zoom Type",
                    "minmargin": "Margem Mínima",
                    "minscale": "Escala Mínima",
                },
                "upload": {
                    "status": "Ativo",
                    "minfeatures": "Nº mínimo de features",
                    "maxfeatures": "Nº máximo de features",
                }
            },
            "options": {
                "zoomtype": {
                    "extent": "Extent",
                    "center": "Center",
                }
            }
        },
        "form": {
            "layers_title": "Temas (Layers)",
            "buttons": {
                "add_cross_resource": "Adicionar cruzamento"
            }
        },
        "help": {
            "name": "Nome identificativo para este mapa",
            "status": "Permite ativar/desativar o mapa",
            "order": "",
            "page_title": "Título da página de impressão",
            "scale": "Se não for definida escala, será feito o <strong>fit</strong> à implantação do edifício",
            "crs": '<a href="https://epsg.org" target="_blank">Código EPSG</a> - Sistemas de referência de coordenadas (CRS)',
            "dpi": "Resolução em dpi para impressão",
            "layers": {
                "no_abstract": "No abstract provided"
            },
            "resources": {
                "resources_title": "Temas adicionados"
            },
            "report": {
                "cross": "",
            },
            "upload": {
                "status": "",
                "minfeatures": "",
                "maxfeatures": "",
            }
        }
    }
}
